/*
 * @Author: jiakaiwen jiakaiwen@huihaiyinhe.com
 * @Date: 2025-09-01 19:16:04
 * @LastEditors: jiakaiwen jiakaiwen@huihaiyinhe.com
 * @LastEditTime: 2025-09-01 21:26:48
 */
import { createSlice, PayloadAction } from '@reduxjs/toolkit'

interface RectifyFormData {
  taskDescription: string
  assignee: string[]
  deadline: any
  photos: any[]
}

interface RectifyState {
  createRectifyDrawerVisible: boolean
  presetPhotos: any[]
  isPhotosLocked: boolean
  formData: RectifyFormData
}

const initialState: RectifyState = {
  createRectifyDrawerVisible: false,
  presetPhotos: [],
  isPhotosLocked: false,
  formData: {
    taskDescription: '',
    assignee: [],
    deadline: null,
    photos: []
  }
}

const rectifySlice = createSlice({
  name: 'rectify',
  initialState,
  reducers: {
    setCreateRectifyDrawerVisible: (state, action: PayloadAction<boolean>) => {
      state.createRectifyDrawerVisible = action.payload
    },
    openRectifyDrawerWithPhotos: (
      state,
      action: PayloadAction<{ photos: any[]; isLocked: boolean }>
    ) => {
      state.createRectifyDrawerVisible = true
      state.presetPhotos = action.payload.photos
      state.isPhotosLocked = action.payload.isLocked
    },
    closeRectifyDrawer: (state) => {
      state.createRectifyDrawerVisible = false
      state.presetPhotos = []
      state.isPhotosLocked = false
      // 清空表单数据
      state.formData = {
        taskDescription: '',
        assignee: [],
        deadline: null,
        photos: []
      }
    },
    setFormData: (state, action: PayloadAction<Partial<RectifyFormData>>) => {
      state.formData = {
        ...state.formData,
        ...action.payload
      }
    },
    clearFormData: (state) => {
      state.formData = {
        taskDescription: '',
        assignee: [],
        deadline: null,
        photos: []
      }
    }
  },
  extraReducers: (builder) => {
    // 处理传统action类型以保持兼容性
    builder.addCase(
      'SET_CREATE_RECTIFY_DRAWER_VISIBLE' as any,
      (state, action: any) => {
        state.createRectifyDrawerVisible = action.payload
      }
    )
  }
})

export const {
  setCreateRectifyDrawerVisible,
  openRectifyDrawerWithPhotos,
  closeRectifyDrawer,
  setFormData,
  clearFormData
} = rectifySlice.actions
export default rectifySlice.reducer
